import React from 'react'
import AddJob from '../AdminJob/JobForm/AddJob/AddJob'
import JobBoard from '../AdminJob/AdminJobBoard/AdminJobBoard'
import Team from '../Team/Team'
import CalendarComponent from './../../Shared/CalendarComponent/CalendarComponent';
import { Box } from '@chakra-ui/react'
import { Redirect, Route, useParams } from 'react-router-dom'

export default function AdminView() {
    let { tenantID } = useParams<any>();

    return (
        <>
            <Route path={`/:tenantID/admin/jobs/:JobID`} component={JobBoard} />

            <Route path={`/:tenantID/admin/job/add`}>
                <AddJob />
            </Route>

            <Route path={`/:tenantID/admin/job/edit/:JobID`}>
                <AddJob />
            </Route>

            <Route path="/:tenantID/admin/team">
                <Team />
            </Route>

            <Route path={`/:tenantID/admin/calendar`}>
                {/* <ScaleFade key="Calendar" initialScale={0.1} in> */}
                <Box
                    background="white"
                    borderWidth="2px"
                    borderStyle="solid"
                    boxShadow={'md'}
                    rounded="md"
                    h="80vh"
                    p="2">
                    <CalendarComponent />
                </Box>
                {/* </ScaleFade> */}
            </Route>

            <Route exact path={`/:tenantID/admin`}>
                <Redirect to={`/${tenantID}/admin/jobs/all`} />
            </Route>

        </>
    )
}
